import { createRoutesFromElements, Navigate, Route } from 'react-router-dom';
import App from 'src/App';
import { ProtectedOnboardingLayout } from 'src/layout/OnboardingTemplate/ProtectedOnboardingLayout';
import { ProtectedAdminPage } from 'src/layout/ProtectedAdminPage/ProtectedAdminPage';
import { ProtectedPageNewUser } from 'src/layout/ProtectedPage/ProtectedPageNewUser';
import { ProtectedPageWithHomeSidebar } from 'src/layout/ProtectedPage/ProtectedPageWithHomeSidebar';
import { ProtectedPageWithProjectSidebar } from 'src/layout/ProtectedPage/ProtectedPageWithProjectSidebar';
import { NoMatchPage } from 'src/views/ErrorPages/NoMatchPage';
import { CustomersPage } from 'src/views/project/CustomersPage';
import { CustomerDetailsPage } from 'src/views/project/CustomersPage/CustomerDetailsPage';
import { SelectProjectPage } from 'src/views/SelectProjectPage/SelectProjectPage';
import { SignInPage } from 'src/views/SignInPage';
import { SignUpPage } from 'src/views/SignUpPage';

// Lazy loaded pages - non-critical pages
import {
ClaimDomainPageLazy,
  CreateOrgPageLazy, CreateProjectPageLazy,   MyProjectsPageLazy, OrgBillingPageLazy,
  OrgSettingsPageV2Lazy, OrgUsersPageLazy,
} from './LazyPages/HomeLazyPages';
import {
  AndiPageLazy,
  ApiKeysPageLazy,
BrowseOperationsPageLazy,   DestinationsPageLazy,
  GeneralSettingsPageLazy, InstallationsPageLazy, IntegrationPageLazy,
  JwtKeysPageLazy,
  NotificationsPageLazy,
  OperationLogsPageLazy,
  OperationsPageLazy,
  ProviderAppsPageLazy,
  TopicsPageLazy,
} from './LazyPages/ProjectLazyPages';

/// ///////////////////////////////////////////

/**
 * Add routes for applications here.
 * In the future can lift and import routes from separate Route components
 * @returns
 */
export const appRoutes = createRoutesFromElements(
  <Route element={<App />}>
    <Route path="/">
      <Route index element={<Navigate to="/home" />} />
      <Route path="new-user" element={ProtectedPageNewUser} />
      <Route path="onboarding" element={ProtectedOnboardingLayout}>
        <Route path="create-org" index element={<CreateOrgPageLazy />} />
        <Route path="claim-domain" element={<ClaimDomainPageLazy />} />
        <Route path="create-project" element={<CreateProjectPageLazy />} />
      </Route>
      <Route path="home" element={ProtectedPageWithHomeSidebar}>
        <Route index element={<MyProjectsPageLazy />} />
        <Route path="projects" element={<MyProjectsPageLazy />} />
        <Route
          path="org-settings"
          element={(
            <ProtectedAdminPage>
              <OrgSettingsPageV2Lazy />
            </ProtectedAdminPage>
          )}
        />
        <Route path="org-users" element={<ProtectedAdminPage><OrgUsersPageLazy /></ProtectedAdminPage>} />
        { import.meta.env.VITE_ALPHA_MODE === 'true' && (
        <Route
          path="org-billing"
          element={(
            <ProtectedAdminPage>
              <OrgBillingPageLazy />
            </ProtectedAdminPage>
              )}
        />
        )}
      </Route>
      <Route path="select-project" element={ProtectedOnboardingLayout}>
        <Route index element={<SelectProjectPage />} />
      </Route>
      <Route path="/projects" element={<Navigate to="/home/projects" />} />
      <Route path="projects/:projectId" element={ProtectedPageWithProjectSidebar}>
        <Route index element={<CustomersPage />} />
        <Route path="integrations" element={<IntegrationPageLazy />} />
        <Route path="integrations/:integrationId" element={<InstallationsPageLazy />} />
        <Route path="integrations/:integrationId/installations/:installationId" element={<OperationsPageLazy />} />
        <Route
          path="integrations/:integrationId/installations/:installationId/browse"
          element={<BrowseOperationsPageLazy />}
        />
        <Route
          path="integrations/:integrationId/installations/:installationId/operations/:operationId"
          element={<OperationLogsPageLazy />}
        />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customers/:groupRef" element={<CustomerDetailsPage />} />
        <Route path="settings" element={<GeneralSettingsPageLazy />} />
        <Route path="provider-apps/:providerId?" element={<ProviderAppsPageLazy />} />
        <Route path="destinations" element={<DestinationsPageLazy />} />
        {import.meta.env.VITE_ALPHA_MODE === 'true' && (
          <Route path="topics" element={<TopicsPageLazy />} />
        )}
        <Route path="andi" element={<AndiPageLazy />} />
        <Route path="andi/chats/new" element={<AndiPageLazy />} />
        <Route path="andi/chats/:chatId" element={<AndiPageLazy />} />
        <Route path="api-keys" element={<ApiKeysPageLazy />} />
        <Route path="notifications" element={<NotificationsPageLazy />} />

        <Route path="jwt-keys" element={<JwtKeysPageLazy />} />
        {/* V2 Sidebar Routes - consolidated home routes under project sidebar */}
        <Route path="home/projects" element={<MyProjectsPageLazy />} />
        <Route
          path="home/org-settings"
          element={(
            <ProtectedAdminPage>
              <OrgSettingsPageV2Lazy />
            </ProtectedAdminPage>
          )}
        />
        <Route path="home/org-users" element={<ProtectedAdminPage><OrgUsersPageLazy /></ProtectedAdminPage>} />
      </Route>
      {/* Custom Sign In */}
      <Route
        path="/sign-in"
        element={<SignInPage />}
      />
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="*" element={NoMatchPage} />
    </Route>
  </Route>,
);
